import {CTA, Breakpoints} from '@volkswagen-onehub/components-core'
import styled from 'styled-components'
import React from 'react'
import {Offers} from '@volkswagen-onehub/icons-core'

export interface HorizontalRFQFixedBannerProps {
    ctaLabel: string
    onClick: () => void
}

const HorizontalRFQFixedBannerContainer = styled.section`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    align-content: center;
    padding: ${(props) => props.theme.size.static250};
    height: 76px;
    background: ${(props) => props.theme.colors.background.primary};
    border-top: ${(props) => props.theme.size.border.default} solid
        ${(props) => props.theme.colors.border.divider};
    z-index: 1;

    @media (min-width: ${Breakpoints.b960}px) {
        padding: ${(props) => props.theme.size.static250}
            ${(props) => props.theme.size.grid001};
    }

    [class^='StyledButtonWrapper-'] {
        grid-column-gap: ${(props) => props.theme.size.static250};
    }
`

export default function HorizontalRFQFixedBanner(
    props: HorizontalRFQFixedBannerProps
): React.JSX.Element {
    return (
        <HorizontalRFQFixedBannerContainer>
            <CTA
                tag="button"
                emphasis="nbab"
                icon={<Offers variant="default" aria-hidden />}
                iconPosition="start"
                aria-label={props.ctaLabel}
                onClick={props.onClick}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: props.ctaLabel,
                    }}
                />
            </CTA>
        </HorizontalRFQFixedBannerContainer>
    )
}
